import {FC} from 'react'
import {Form} from 'react-bootstrap'
import {Grouping, EconomyOption} from '../../groupings/core/_models'
import {getISO2ByISO3} from '../../../../libs/misc'

type Props = {
  groupingDetail: Grouping
}

const GroupingsDetailView: FC<Props> = ({groupingDetail}) => {
  const renderValue = (value?: string | number | boolean | null) => {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return String(value)
  }

  return (
    <div className='detail-agreement'>
      <h3>General Information</h3>
      <div className='row mb-4'>
        <div className='col-md-6 mb-3'>
          <Form.Label>Group Code</Form.Label>
          <div className='data-value'>{renderValue(groupingDetail.grp)}</div>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label>Title</Form.Label>
          <div className='data-value'>{renderValue(groupingDetail.title)}</div>
        </div>
      </div>

      <hr />
      <h3>Participation & Display</h3>
      <div className='row mb-4'>
        <div className='col-md-12 mb-3'>
          <Form.Label>Economies</Form.Label>
          <div className='data-value'>
            {groupingDetail.economies.length > 0 ? (
              <div className='d-flex flex-wrap gap-2'>
                {groupingDetail.economies.split(';').map((econ, idx) => {
                  const iso = econ.trim()
                  const iso2 = getISO2ByISO3(iso)

                  return iso === 'EUN' || !iso2 ? (
                    <span key={idx} className='badge bg-dark me-1'>
                      {iso}
                    </span>
                  ) : (
                    <span key={idx} className={`fi fi-${iso2.toLowerCase()} me-2`} title={iso} />
                  )
                })}
              </div>
            ) : (
              '-'
            )}
          </div>
        </div>

        <div className='col-md-6 mb-3'>
          <Form.Label>Customs Union</Form.Label>
          <div className='data-value'>{groupingDetail.customs_union === 1 ? 'Yes' : 'No'}</div>
        </div>

        <div className='col-md-6 mb-3'>
          <Form.Label>Display Multiple</Form.Label>
          <div className='data-value'>{groupingDetail.diplay_multiple === 1 ? 'Yes' : 'No'}</div>
        </div>
      </div>
    </div>
  )
}

export default GroupingsDetailView
